(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norifox-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('norifox-cart-page')) {
    class NorifoxCartPage extends HTMLElement {
      connectedCallback() {
        this.life?.abort();
        this.life = new AbortController();
        const signal = this.life.signal;
        this.busy = false;
        this.synced = true;
        this.dataset.enhanced = 'true';
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-nfc-quantity]')) this.changeQuantity(event.target);
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && event.target.matches('[data-nfc-quantity]')) { event.preventDefault(); this.changeQuantity(event.target); }
        }, { signal });
        this.addEventListener('submit', (event) => {
          if (event.target.matches('[data-nfc-variant-form]')) { event.preventDefault(); this.saveVariant(); return; }
          if (this.busy || !this.synced) event.preventDefault();
        }, { signal });
        this.addEventListener('close', () => this.releaseDialog(), { capture: true, signal });
        this.addEventListener('cancel', (event) => { if (this.busy) event.preventDefault(); }, { capture: true, signal });
        this.media = matchMedia('(max-width: 749px)');
        this.media.addEventListener('change', () => this.observeRail(), { signal });
        window.addEventListener('pageshow', (event) => { if (event.persisted) this.refresh(); }, { signal });
        this.observeRail();
        this.updateState();
      }

      disconnectedCallback() { this.life?.abort(); this.railObserver?.disconnect(); this.releaseDialog(); }

      observeRail() {
        this.railObserver?.disconnect();
        const rail = this.querySelector('[data-nfc-rail]');
        const sticky = rail && (this.media.matches ? this.dataset.stickyMobile : this.dataset.stickyDesktop) === 'true';
        this.toggleAttribute('data-sticky-enabled', Boolean(sticky));
        const measure = () => {
          if (sticky && this.isConnected) document.documentElement.style.setProperty('--nfc-cart-rail-height', `${Math.ceil(rail.getBoundingClientRect().height)}px`);
        };
        if (rail && typeof ResizeObserver === 'function') { this.railObserver = new ResizeObserver(measure); this.railObserver.observe(rail); }
        measure();
      }

      updateState() {
        this.dataset.busy = String(this.busy);
        this.setAttribute('aria-busy', String(this.busy));
        this.querySelectorAll('[data-nfc-step], [data-nfc-save], [data-nfc-close]').forEach((button) => {
          if (!button.hasAttribute('data-idle-disabled')) button.dataset.idleDisabled = String(button.disabled);
          button.disabled = this.busy || !this.synced || button.dataset.idleDisabled === 'true';
        });
        this.querySelectorAll('[data-nfc-quantity]').forEach((input) => { input.readOnly = this.busy || !this.synced || input.hasAttribute('data-quantity-locked'); });
        const checkout = this.querySelector('[data-nfc-checkout]');
        if (checkout) checkout.disabled = this.busy || !this.synced || this.querySelector('[data-nfc-rail]')?.dataset.checkoutLocked === 'true';
        const express = this.querySelector('[data-nfc-express]');
        if (express) express.inert = this.busy || !this.synced;
      }

      onClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const action = target.closest('[data-nfc-step], [data-nfc-remove], [data-nfc-change], [data-nfc-reload], [data-nfc-close]');
        if (!action || !this.contains(action)) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (action.matches('[data-nfc-change]') && typeof this.querySelector('[data-nfc-dialog]')?.showModal !== 'function') return;
        event.preventDefault();
        if (this.busy) return;
        if (action.matches('[data-nfc-reload]')) { this.refresh(); return; }
        if (!this.synced) return;
        if (action.matches('[data-nfc-close]')) { this.querySelector('[data-nfc-dialog]')?.close(); return; }
        const row = action.closest('[data-nfc-item]');
        if (action.matches('[data-nfc-change]')) { this.openVariant(row, action); return; }
        if (action.matches('[data-nfc-remove]')) { this.changeLine(row, 0); return; }
        const input = row.querySelector('[data-nfc-quantity]');
        const next = Number(input.value) + Number(action.dataset.nfcStep) * Number(input.step || 1);
        if (next < Number(input.min || 1) || (input.hasAttribute('max') && next > Number(input.max))) return;
        input.value = String(next);
        this.changeQuantity(input);
      }

      changeQuantity(input) {
        if (this.busy || !this.synced || input.hasAttribute('data-quantity-locked')) return;
        if (!input.checkValidity() || !Number.isSafeInteger(Number(input.value))) { input.reportValidity(); input.value = input.dataset.originalQuantity; this.message(this.dataset.quantityError); return; }
        const quantity = Number(input.value);
        if (quantity === Number(input.dataset.originalQuantity)) return;
        this.changeLine(input.closest('[data-nfc-item]'), quantity);
      }

      async changeLine(row, quantity) {
        const focus = { index: Number(row.dataset.lineIndex), quantity: quantity > 0 };
        await this.run(async () => {
          const cart = await this.request(this.dataset.changeUrl, { id: row.dataset.lineKey, quantity, sections: [this.dataset.sectionId], sections_url: this.dataset.cartUrl });
          await this.renderCart(cart, focus);
        });
      }

      async request(url, body) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.dataset.error);
          return data;
        } finally { clearTimeout(timer); }
      }

      async run(work) {
        if (this.busy) return;
        this.busy = true;
        this.message('');
        this.status(this.dataset.updating);
        this.updateState();
        try {
          await work();
          this.synced = true;
          this.status(this.dataset.updated);
        } catch (error) {
          this.closeDialog();
          let reconciled = false;
          try { const cart = await this.request(`${this.dataset.cartUrl}.js`); await this.renderCart(cart); reconciled = true; } catch { this.synced = false; }
          this.message(reconciled ? (error.message || this.dataset.error) : this.dataset.reloadError);
          const reload = this.querySelector('[data-nfc-reload]');
          if (reload) reload.hidden = reconciled;
        } finally { this.busy = false; this.updateState(); }
      }

      async refresh() { await this.run(async () => { const cart = await this.request(`${this.dataset.cartUrl}.js`); await this.renderCart(cart); }); }

      async renderCart(cart, focus) {
        if (!Array.isArray(cart.items)) throw new Error(this.dataset.error);
        let html = cart.sections?.[this.dataset.sectionId];
        if (!html) {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error(this.dataset.reloadError);
          html = await response.text();
        }
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.querySelector('norifox-cart-page [data-nfc-view]');
        if (!replacement || !this.isConnected) throw new Error(this.dataset.reloadError);
        this.closeDialog();
        this.querySelector('[data-nfc-view]').replaceWith(replacement);
        this.synced = true;
        this.observeRail();
        this.updateState();
        document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); node.hidden = cart.item_count === 0; });
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: this.id, data: { source: 'norifox-cart', itemCount: cart.item_count, sections: { [this.dataset.sectionId]: html } } } }));
        if (focus) {
          const rows = [...this.querySelectorAll('[data-nfc-item]')];
          const row = rows[Math.min(focus.index, rows.length - 1)];
          (row?.querySelector(focus.quantity ? '[data-nfc-quantity]' : '.nfc__name a') || this.querySelector('[data-nfc-heading]'))?.focus({ preventScroll: true });
        }
      }

      message(text) { const node = this.querySelector('[data-nfc-error]'); if (node) { node.textContent = text; node.hidden = !text; } }
      status(text) { const node = this.querySelector('[data-nfc-status]'); if (node) node.textContent = text; }

      openVariant(row, trigger) {
        const source = row.querySelector('[data-nfc-line-variants]');
        const dialog = this.querySelector('[data-nfc-dialog]');
        if (!source || !dialog) return;
        this.variantRow = row;
        this.variantTrigger = trigger;
        const select = dialog.querySelector('[data-nfc-variant-select]');
        select.replaceChildren(...[...source.options].map((option) => option.cloneNode(true)));
        select.value = row.dataset.variantId;
        dialog.querySelector('[data-nfc-dialog-product]').textContent = row.querySelector('.nfc__name').textContent.trim();
        dialog.querySelector('[data-nfc-option-label]').textContent = [...row.querySelectorAll('.nfc__options dt')].map((node) => node.textContent.replace(/:$/, '')).join(' / ');
        dialog.querySelector('[data-nfc-dialog-error]').hidden = true;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        select.focus();
      }

      closeDialog() { const dialog = this.querySelector('[data-nfc-dialog]'); if (dialog?.open) dialog.close(); this.releaseDialog(); }

      releaseDialog() {
        if (this.previousOverflow !== undefined) { document.documentElement.style.overflow = this.previousOverflow; this.previousOverflow = undefined; }
        if (this.variantTrigger?.isConnected) this.variantTrigger.focus({ preventScroll: true });
        this.variantTrigger = null;
      }

      sameProperties(a, b) {
        const normalized = (value) => JSON.stringify(Object.entries(Array.isArray(value) ? Object.fromEntries(value) : value || {}).sort(([x], [y]) => x.localeCompare(y)));
        return normalized(a) === normalized(b);
      }

      matching(cart, variantId, properties) { return cart.items.filter((item) => String(item.variant_id) === String(variantId) && !item.selling_plan_allocation && !item.parent_relationship && this.sameProperties(item.properties, properties)); }

      distribution(cart, oldId, newId, properties) {
        const rows = cart.items.filter((item) => !([String(oldId), String(newId)].includes(String(item.variant_id)) && this.sameProperties(item.properties, properties)));
        return JSON.stringify(rows.map((item) => [item.variant_id, item.quantity, Object.entries(item.properties || {}).sort(), item.selling_plan_allocation?.selling_plan?.id || null]).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
      }

      async saveVariant() {
        if (this.busy || !this.variantRow?.isConnected) return;
        const row = this.variantRow;
        const select = this.querySelector('[data-nfc-variant-select]');
        const selected = select.selectedOptions[0];
        const newId = select.value;
        if (!selected || selected.disabled) return;
        if (newId === row.dataset.variantId) { this.closeDialog(); return; }
        const originalQuantity = Number(row.querySelector('[data-nfc-quantity]').dataset.originalQuantity);
        const minimum = Number(selected.dataset.min || 1);
        const increment = Number(selected.dataset.step || 1);
        if (originalQuantity < minimum || (originalQuantity - minimum) % increment !== 0 || (selected.dataset.max && originalQuantity > Number(selected.dataset.max))) {
          const node = this.querySelector('[data-nfc-dialog-error]'); node.textContent = this.dataset.quantityError; node.hidden = false; return;
        }
        await this.run(async () => {
          const before = await this.request(`${this.dataset.cartUrl}.js`);
          const rawProperties = JSON.parse(row.dataset.properties || '{}') || {};
          const properties = Array.isArray(rawProperties) ? Object.fromEntries(rawProperties) : rawProperties;
          const originalMatches = this.matching(before, row.dataset.variantId, properties);
          const targetMatches = this.matching(before, newId, properties);
          if (originalMatches.length !== 1 || targetMatches.length > 1 || originalMatches[0].quantity !== originalQuantity) throw new Error(this.dataset.staleError);
          const original = originalMatches[0];
          const previousTargetQuantity = targetMatches[0]?.quantity || 0;
          const expectedTargetQuantity = previousTargetQuantity + original.quantity;
          let started = false;
          try {
            started = true;
            await this.request(this.dataset.addUrl, { items: [{ id: Number(newId), quantity: original.quantity, properties }] });
            const added = await this.request(`${this.dataset.cartUrl}.js`);
            const oldLines = this.matching(added, original.variant_id, properties);
            const newLines = this.matching(added, newId, properties);
            if (oldLines.length !== 1 || oldLines[0].quantity !== original.quantity || newLines.length !== 1 || newLines[0].quantity !== expectedTargetQuantity || this.distribution(before, original.variant_id, newId, properties) !== this.distribution(added, original.variant_id, newId, properties)) throw new Error(this.dataset.variantError);
            const updated = await this.request(this.dataset.changeUrl, { id: oldLines[0].key, quantity: 0, sections: [this.dataset.sectionId], sections_url: this.dataset.cartUrl });
            if (this.matching(updated, original.variant_id, properties).length || this.matching(updated, newId, properties).length !== 1 || this.matching(updated, newId, properties)[0].quantity !== expectedTargetQuantity) throw new Error(this.dataset.variantError);
            await this.renderCart(updated, { index: Number(row.dataset.lineIndex), quantity: true });
          } catch (error) {
            if (started) {
              const latest = await this.request(`${this.dataset.cartUrl}.js`);
              const oldLines = this.matching(latest, original.variant_id, properties);
              const newLines = this.matching(latest, newId, properties);
              if (oldLines.length === 0 && newLines.length === 1 && newLines[0].quantity === expectedTargetQuantity) { await this.renderCart(latest); return; }
              const extra = (newLines[0]?.quantity || 0) - previousTargetQuantity;
              const safe = oldLines.length === 1 && oldLines[0].quantity === original.quantity && newLines.length === 1 && extra > 0 && extra <= original.quantity && this.distribution(before, original.variant_id, newId, properties) === this.distribution(latest, original.variant_id, newId, properties);
              if (safe) await this.request(this.dataset.changeUrl, { id: newLines[0].key, quantity: previousTargetQuantity });
            }
            throw new Error(error.message || this.dataset.variantError);
          }
        });
      }
    }
    customElements.define('norifox-cart-page', NorifoxCartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norifox-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('norifox-footer-v2')) {
    class NorifoxFooterV2 extends HTMLElement {
      connectedCallback() {
        if (this.menuMedia) return;

        this.menuMedia = window.matchMedia('(max-width: 749px)');
        this.menuDetails = Array.from(this.querySelectorAll('.nfx-footer-v2__menu-details'));
        this.updateMenus = () => {
          const collapsible = this.menuMedia.matches && this.dataset.collapseMenus === 'true';

          this.menuDetails.forEach((details) => {
            const summary = details.querySelector('summary');
            details.open = !collapsible;
            summary.tabIndex = collapsible ? 0 : -1;

            if (collapsible) {
              summary.removeAttribute('aria-disabled');
            } else {
              summary.setAttribute('aria-disabled', 'true');
            }
          });
        };

        this.handleMenuClick = (event) => {
          const summary = event.target.closest('.nfx-footer-v2__menu-summary');
          if (!summary || !this.contains(summary)) return;

          if (!this.menuMedia.matches || this.dataset.collapseMenus !== 'true') {
            event.preventDefault();
          }
        };

        this.handleBlockSelect = (event) => {
          const details = event.target.closest('.nfx-footer-v2__menu')?.querySelector('details');
          if (details && this.contains(details)) details.open = true;
        };

        this.menuMedia.addEventListener('change', this.updateMenus);
        this.addEventListener('click', this.handleMenuClick);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.updateMenus();
      }

      disconnectedCallback() {
        if (!this.menuMedia) return;
        this.menuMedia.removeEventListener('change', this.updateMenus);
        this.removeEventListener('click', this.handleMenuClick);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.menuMedia = null;
      }
    }

    customElements.define('norifox-footer-v2', NorifoxFooterV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norifox-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('norifox-discovery-header')) {
    class NorifoxDiscoveryHeader extends HTMLElement {
      connectedCallback() {
        this.searchStates?.forEach(state=>this.cancelSearch(state));
        this.detailTimers?.forEach(timer=>clearTimeout(timer));
        this.life?.abort();
        this.life = new AbortController();
        const signal = this.life.signal;
        this.menu = this.querySelector('[data-nfx-menu-dialog]');
        this.searchDialog = this.querySelector('[data-nfx-search-dialog]');
        this.details = [...this.querySelectorAll('[data-nfx-details]')];
        this.tabs = [...this.querySelectorAll('[data-nfx-tab]')];
        this.panels = [...this.querySelectorAll('[data-nfx-panel]')];
        this.searchStates = new Map();
        this.dataset.enhanced = 'true';
        this.querySelectorAll('[data-nfx-open-menu], [data-nfx-open-search]').forEach((trigger) => trigger.setAttribute('role', 'button'));
        this.querySelector('[data-nfx-tabs]')?.setAttribute('role', 'tablist');
        this.tabs.forEach((tab) => tab.setAttribute('role', 'tab'));
        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs.find((tab) => tab.dataset.nfxTab === panel.dataset.nfxPanel)?.id || '');
          panel.tabIndex = 0;
        });
        this.selectTab(this.tabs.find((tab) => tab.dataset.nfxTab === this.dataset.defaultTab) || this.tabs[0]);
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('keydown', (event) => this.handleKey(event), { signal });
        this.detailTimers=new Map();
        this.hover=matchMedia('(hover:hover) and (pointer:fine)');
        this.details.forEach(item=>{
          item.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&this.hover.matches&&!this.media.matches)this.showDetail(item,true);},{signal});
          item.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'&&this.hover.matches&&!item.contains(document.activeElement)){clearTimeout(this.detailTimers.get(item));this.detailTimers.set(item,setTimeout(()=>this.closeDetail(item),130));}},{signal});
        });
        this.details.forEach((item) => item.addEventListener('toggle', () => {
          if (item.open) {
            this.closeSearchResults();
            this.details.forEach((other) => { if (other !== item) this.closeDetail(other,true); });
          }
        }, { signal }));
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) { this.closeDetails(); this.closeSearchResults(); }
        }, { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || this.menu?.open || this.searchDialog?.open) return;
          const openDetail = this.details.find((item) => item.open);
          if (openDetail) { event.preventDefault(); this.closeDetail(openDetail); openDetail.querySelector('summary')?.focus({preventScroll:true}); }
        }, { signal });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('close', () => this.releaseDialog(dialog), { signal });
          dialog.addEventListener('cancel',event=>{if(dialog===this.searchDialog){event.preventDefault();this.closeDialog(dialog);}},{signal});
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog(dialog);
          }, { signal });
        });
        
        this.cartObserver?.disconnect();
        this.cartObserver = new MutationObserver(() => this.updateCartLabels());
        this.querySelectorAll('[data-cart-count]').forEach((count) => this.cartObserver.observe(count, { childList: true, characterData: true, subtree: true }));
        this.updateCartLabels();
        ['cart:update', 'cart:refresh'].forEach((name) => document.addEventListener(name, () => this.queueCartRefresh(), { signal }));
        window.addEventListener('pageshow', (event) => { if (event.persisted) this.queueCartRefresh(); }, { signal });
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.queueCartRefresh(); }, { signal });
        this.media = matchMedia(`(max-width: ${Number(this.dataset.mobileBreakpoint) || 1100}px)`);
        this.media.addEventListener('change', () => { this.closeDetails(); if (this.menu?.open) this.menu.close(); this.closeSearchResults(); }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          if (this.media.matches) {
            this.openDialog(this.menu, this.querySelector('[data-nfx-open-menu]'));
          } else if (event.target.closest('.nfx-hd__series-column, .nfx-hd__preview-column')) {
            this.details[0].open = true;
          } else {
            const item = event.target.closest('details');
            if (item) item.open = true;
          }
        }, { signal });
      }

      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach((dialog) => this.releaseDialog(dialog));
        this.life?.abort();
        this.cartObserver?.disconnect();
        clearTimeout(this.cartTimer);
        this.cartRequest?.abort();
        this.searchStates?.forEach(state=>this.cancelSearch(state));
        this.detailTimers?.forEach(timer=>clearTimeout(timer));
        clearTimeout(this.dialogTimer);cancelAnimationFrame(this.enterFrame);cancelAnimationFrame(this.enterFrame2);
      }

      showDetail(item, fromHover=false) {
        clearTimeout(this.detailTimers.get(item));item.classList.remove('nfx-closing');
        if(item.open)return;
        this.details.forEach(other=>{if(other!==item)this.closeDetail(other,true);});
        item.nfxHovered=fromHover;
        item.classList.add('nfx-revealing');item.open=true;item.querySelector('summary')?.setAttribute('aria-expanded','true');
        requestAnimationFrame(()=>requestAnimationFrame(()=>{if(item.isConnected)item.classList.remove('nfx-revealing');}));
      }
      closeDetail(item, immediate=false) {
        clearTimeout(this.detailTimers.get(item));
        if(!item.open)return;
        const finish=()=>{item.open=false;item.classList.remove('nfx-closing','nfx-revealing');};
        item.querySelector('summary')?.setAttribute('aria-expanded','false');
        if(immediate||matchMedia('(prefers-reduced-motion: reduce)').matches){finish();return;}
        item.classList.remove('nfx-revealing');item.classList.add('nfx-closing');
        this.detailTimers.set(item,setTimeout(finish,200));
      }
      closeDetails() { this.details.forEach(item=>this.closeDetail(item,true)); }

      handleClick(event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const menuTrigger = target.closest('[data-nfx-open-menu]');
        if (menuTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && typeof this.menu?.showModal === 'function') { event.preventDefault(); this.openDialog(this.menu, menuTrigger); return; }
        const searchTrigger = target.closest('[data-nfx-open-search]');
        if (searchTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && typeof this.searchDialog?.showModal === 'function') { event.preventDefault(); this.openDialog(this.searchDialog, searchTrigger); return; }
        if (target.closest('[data-nfx-close]')) { this.closeDialog(target.closest('dialog')); return; }
        const summary=target.closest('[data-nfx-details]>summary');
        if(summary){event.preventDefault();const item=summary.parentElement;if(item.open&&item.nfxHovered){item.nfxHovered=false;this.showDetail(item);return;}if(item.open)this.closeDetail(item);else this.showDetail(item);return;}
        const tab = target.closest('[data-nfx-tab]');
        if (tab) this.selectTab(tab);
        if (target.closest('[data-nhp-search-close]')) { const form = target.closest('form'); const input = form.querySelector('[data-nfx-search]'); const state = this.searchStates.get(input); if (state) this.hideSearch(state); input.focus(); return; }
        const cartLink = target.closest('[data-nfx-cart]');
        if (cartLink && this.dataset.pageType !== 'cart' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !window.NoriFoxCartDrawerReady) {
          const drawer = document.querySelector('cart-drawer-component');
          if (typeof drawer?.showDialog === 'function') { event.preventDefault(); drawer.showDialog(); }
        }
      }

      handleKey(event) {
        const trigger = event.target.closest?.('[data-nfx-open-menu], [data-nfx-open-search]');
        if (trigger && event.key === ' ') { event.preventDefault(); trigger.click(); return; }
        const tab = event.target.closest?.('[data-nfx-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let index = this.tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.tabs.length - 1;
        this.selectTab(this.tabs[index]);
        this.tabs[index].focus();
      }

      selectTab(active) {
        if (!active) return;
        this.tabs.forEach((tab) => { const selected = tab === active; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.nfxPanel !== active.dataset.nfxTab; });
      }

      openDialog(dialog, trigger) {
        if (!dialog) return;
        clearTimeout(this.dialogTimer);dialog.classList.remove('nfx-closing');
        if(dialog.open){if(dialog===this.searchDialog){const input=dialog.querySelector('[data-nfx-search]');input.focus({preventScroll:true});const state=this.searchStates.get(input);if(state)this.queueSearch(state);}return;}
        this.querySelectorAll('dialog[open]').forEach((other) => { other.close(); this.releaseDialog(other); });
        this.closeDetails();
        this.closeSearchResults();
        dialog.nfxTrigger = trigger;
        dialog.nfxReturnMenu = dialog===this.searchDialog && trigger?.closest('[data-nfx-menu-dialog]')===this.menu;
        if(dialog===this.searchDialog)dialog.classList.add('nfx-entering');
        this.previousOverflow=document.documentElement.style.overflow;
        this.previousPadding=document.documentElement.style.paddingInlineEnd;
        const scrollbar=Math.max(0,(window.innerWidth||0)-(document.documentElement.getBoundingClientRect?.()?.width||document.documentElement.clientWidth||window.innerWidth||0));
        const padding=parseFloat(getComputedStyle(document.documentElement).paddingInlineEnd)||0;
        if(scrollbar)document.documentElement.style.paddingInlineEnd=(padding+scrollbar)+'px';
        document.documentElement.style.overflow='hidden';
        dialog.showModal();
        if(dialog===this.searchDialog)this.enterFrame=requestAnimationFrame(()=>{this.enterFrame2=requestAnimationFrame(()=>dialog.classList.remove('nfx-entering'));});
        this.activeDialog = dialog;

        trigger?.setAttribute('aria-expanded', 'true');
        if (dialog === this.searchDialog) {
          const input=dialog.querySelector('[data-nfx-search]');
          this.setupSearch(input,this.life.signal);input.focus({preventScroll:true});
          this.queueSearch(this.searchStates.get(input));
        }
      }

      closeDialog(dialog) {
        if(!dialog?.open)return;
        if(dialog!==this.searchDialog){dialog.close();return;}
        this.closeSearchResults();cancelAnimationFrame(this.enterFrame);cancelAnimationFrame(this.enterFrame2);
        clearTimeout(this.dialogTimer);dialog.classList.remove('nfx-entering');
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){dialog.close();return;}
        dialog.classList.add('nfx-closing');
        this.dialogTimer=setTimeout(()=>{if(dialog.open)dialog.close();dialog.classList.remove('nfx-closing');},250);
      }

      releaseDialog(dialog) {
        if (this.activeDialog !== dialog) return;
        this.activeDialog = null;
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        document.documentElement.style.paddingInlineEnd=this.previousPadding??'';
        dialog.nfxTrigger?.setAttribute('aria-expanded', 'false');
        if(dialog.nfxReturnMenu&&this.isConnected){dialog.nfxReturnMenu=false;this.openDialog(this.menu,this.querySelector('[data-nfx-open-menu]'));}
        if (dialog.nfxTrigger?.isConnected && this.isConnected) dialog.nfxTrigger.focus({preventScroll:true});
        this.closeSearchResults();
      }

      setupSearch(input, signal) {
        if (this.searchStates.has(input)) return;
        const form = input.closest('form');
        const state = {input, form, box:form.querySelector('[data-nfx-results]'), list:form.querySelector('[data-nfx-result-list]'), status:form.querySelector('[data-nfx-status]'), all:form.querySelector('[data-nfx-all-products]'), cache:new Map(), version:0, timer:0, request:null, loadingTimer:0, queued:null, rendered:null};
        this.searchStates.set(input,state);
        const update = () => this.queueSearch(state);
        input.addEventListener('input',event=>{if(!event.isComposing)update();}, {signal});
        input.addEventListener('compositionend',update,{signal});
        form.addEventListener('keydown',event=>{
          if(event.key==='Escape'){event.preventDefault();event.stopPropagation();this.closeDialog(this.searchDialog);return;}
          if(!['ArrowDown','ArrowUp'].includes(event.key))return;
          const links=[...state.list.querySelectorAll('a'),state.all].filter(el=>el&&!el.disabled);
          const index=links.indexOf(event.target);
          if(event.target!==input&&index<0)return;
          event.preventDefault();
          const next=event.target===input?(event.key==='ArrowDown'?links[0]:links.at(-1)):links[index+(event.key==='ArrowDown'?1:-1)];
          (next||input).focus({preventScroll:true});
        },{signal});
        form.addEventListener('submit',()=>this.cancelSearch(state),{signal});
      }

      cancelSearch(state) {
        clearTimeout(state.timer);clearTimeout(state.loadingTimer);
        state.timer=0;state.loadingTimer=0;
        state.request?.abort();state.request=null;state.version+=1;
        state.box.removeAttribute('aria-busy');state.box.removeAttribute('data-loading');
      }

      queueSearch(state) {
        const query=state.input.value.trim();
        if(query===state.queued&&(state.timer||state.request))return;
        this.cancelSearch(state);state.queued=query;state.all.disabled=!query;
        if(!query){state.list.replaceChildren();state.status.textContent='';state.rendered=null;return;}
        if(this.dataset.predictive!=='true')return;
        if(state.cache.has(query)){this.renderSearch(state,state.cache.get(query),query);return;}
        const version=state.version;
        state.timer=setTimeout(()=>{state.timer=0;this.search(state,query,version);},125);
      }

      renderSearch(state, html, query) {
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const list=parsed.querySelector('[data-nhp-suggestions]');
        if(!list)throw new Error('Search response missing product list');
        const nodes=[...list.querySelectorAll(':scope > [data-nfx-product-result]')].map(node=>document.importNode(node,true));
        state.list.replaceChildren(...nodes);state.rendered=query;
        state.status.textContent=nodes.length?this.dataset.searchResults:this.dataset.searchEmpty;
        if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&state.list.animate)state.list.animate([{opacity:.55,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'cubic-bezier(.22,.61,.36,1)'});
      }

      async search(state, query, version) {
        const request=new AbortController();state.request=request;
        state.box.setAttribute('aria-busy','true');
        state.loadingTimer=setTimeout(()=>{if(state.version===version&&!request.signal.aborted){state.box.setAttribute('data-loading','');state.status.textContent=this.dataset.searchLoading;}},180);
        try {
          const url=new URL(this.dataset.searchEndpoint,location.origin);
          url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');
          url.searchParams.set('section_id','norifox-home-suggestions');url.searchParams.set('resources[limit]','6');
          url.searchParams.set('resources[options][unavailable_products]','last');
          const response=await fetch(url,{signal:request.signal,headers:{Accept:'text/html'}});
          if(!response.ok)throw new Error('Search unavailable');
          const html=await response.text();
          if(request.signal.aborted||state.version!==version||!this.isConnected||!this.searchDialog.open)return;
          this.renderSearch(state,html,query);state.cache.set(query,html);
          if(state.cache.size>20)state.cache.delete(state.cache.keys().next().value);
        } catch(error) {
          if(!request.signal.aborted&&state.version===version&&this.isConnected&&this.searchDialog.open)state.status.textContent=this.dataset.searchError;
        } finally {
          if(state.version===version){clearTimeout(state.loadingTimer);state.loadingTimer=0;state.request=null;state.box.removeAttribute('aria-busy');state.box.removeAttribute('data-loading');}
        }
      }

      hideSearch(state) { this.cancelSearch(state); }
      closeSearchResults() { this.searchStates?.forEach(state=>this.cancelSearch(state)); }

      updateCartLabels() {
        this.querySelectorAll('[data-nfx-cart]').forEach((link) => {
          const count = link.querySelector('[data-cart-count]');
          const value = Number.parseInt(count?.textContent || '0', 10) || 0;
          if (count) count.hidden = value === 0 || this.dataset.hideCartCount === 'true';
          link.setAttribute('aria-label', `${link.dataset.nfxCartLabel}${value ? ` (${value})` : ''}`);
        });
      }

      queueCartRefresh() { clearTimeout(this.cartTimer); this.cartTimer = setTimeout(() => this.refreshCart(), 100); }

      async refreshCart() {
        this.cartRequest?.abort();
        this.cartRequest = new AbortController();
        const signal = this.cartRequest.signal;
        try {
          const response = await fetch(this.dataset.cartUrl, { signal, headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          if (signal.aborted || !this.isConnected || !Number.isInteger(cart.item_count)) return;
          this.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = String(cart.item_count); });
          this.updateCartLabels();
        } catch {}
      }
    }
    customElements.define('norifox-discovery-header', NorifoxDiscoveryHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
